import { Injectable, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";

import { Application } from "@jct/core";

import {
  LOCALE_PROVIDER,
  SUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE,
  MULTIPLE_LOCALIZATION_FEATURE,
} from "./core";
import { Language } from "./language";

declare const $localize: { locale?: string };

let firstTime = true;

@Injectable({
  providedIn: "root",
})
export class Localization {
  private _enabled = true;

  constructor(
    @Inject(DOCUMENT) document: Document,
    private application: Application
  ) {
    let current = this.current;

    LOCALE_PROVIDER.useValue = current.code;

    if (firstTime) {
      firstTime = false;
      document.documentElement.setAttribute("dir", current.layout);
      document.documentElement.setAttribute("lang", current.code);
    }
  }

  get code() {
    return this.current.code;
  }

  get current() {
    return (
      this._languageFromPath() || this._languageFromBundle() || DEFAULT_LANGUAGE
    );
  }

  private _languageFromPath(): Language {
    return SUPPORTED_LANGUAGES.find(
      (x) =>
        location.pathname.startsWith(`/${x.code}/`) ||
        location.pathname === `/${x.code}`
    );
  }

  // A localized bundle knows its own locale even when it is not served under a
  // /<code>/ path — `ng serve --configuration=en` serves it from the root.
  // Keep the `typeof $localize !== "undefined" && $localize.locale` form: that is
  // the exact expression @angular/localize inlines at build time.
  private _languageFromBundle(): Language {
    let locale = typeof $localize !== "undefined" && $localize.locale;

    if (!locale) {
      return undefined;
    }

    let code = locale.split("-")[0].toLowerCase();

    return SUPPORTED_LANGUAGES.find((x) => x.code === code);
  }

  change(target: Language) {
    if (this._enabled) {
      let current = this.current;
      let urlPart = `/${current.code}/`;

      if (target.code != current.code) {
        let path = location.pathname;

        if (location.pathname.startsWith(urlPart)) {
          path = location.pathname.substring(urlPart.length);
        }

        // if (DEFAULT_LANGUAGE.code == target.code) {
        //   location.pathname = `${path}`;
        // } else {
        location.pathname = `/${target.code}/${path}`;
        // }
      }
    }
  }

  enable() {
    this._enabled = true;
  }

  get enabled() {
    return this.application.settings[MULTIPLE_LOCALIZATION_FEATURE] === true;
  }
}
